import { Link, useNavigate, useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";

export default function Register() {
  const navigate = useNavigate();
  const location = useLocation();
  const apiData = location.state;

  const [formData, setFormData] = useState({
    full_name: "",
    mobile: "",
    gender: "",
    dob: "",
    age: "",
    religion: "",
    caste: "",
    district: "",
    taluk: "",
    email: "",
    jobType: "",
    password: "",
    agree: false,
  });

  // Prefill from API data
  useEffect(() => {
    if (apiData) {
      setFormData((prev) => ({
        ...prev,
        full_name: apiData.full_name || "",
        mobile: apiData.mobile || "",
      }));
    }
  }, [apiData]);

  // handle input change
  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;

    if (name === "dob") {
      const birthDate = new Date(value);
      if (!isNaN(birthDate.getTime())) {
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) age--;
        setFormData((prev) => ({ ...prev, dob: value, age: String(age) }));
      } else {
        setFormData((prev) => ({ ...prev, dob: value, age: "" }));
      }
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // handle submit with API POST
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      console.log("📤 Sending data to API:", formData);

      const res = await fetch("https://matrimony.nalavariyam.org/api/phoneverify", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await res.json();
      console.log("✅ API Response:", data);

      if (res.ok && data?.status === "success") {
        sessionStorage.setItem("userDetails", JSON.stringify(data));
        alert("Registration successful!");
        navigate("/profile");
      } else {
        alert("Something went wrong: " + (data?.message || "Unknown error"));
      }
    } catch (err) {
      console.error("❌ Error submitting form:", err);
      alert("Network error, please try again.");
    }
  };

  return (
    <div>
       {/* <!-- PRELOADER --> */}
    {/* <div id="preloader"> 
        <div className="plod">
            <span className="lod1"><img src="images/loder/1.png" alt="" loading="lazy"/></span>      
            <span className="lod2"><img src="images/loder/2.png" alt="" loading="lazy"/></span>
            <span className="lod3"><img src="images/loder/3.png" alt="" loading="lazy"/></span>
        </div>
    </div>
    <div className="pop-bg"></div> */}
    {/* <!-- END PRELOADER --> */}

    {/* <!-- SEARCH --> */}
    <div className="pop-search">
        <span className="ser-clo">+</span>
        <div className="inn">
            <form>
                <input type="text" placeholder="Search here..."/>
            </form>
            <div className="rel-sear"> 
                <h4>Top searches:</h4>
                <a href="all-profiles.html">Browse all profiles</a>
                <a href="all-profiles.html">Mens profile</a>
                <a href="all-profiles.html">Female profile</a>
                <a href="all-profiles.html">New profiles</a>
            </div>
        </div>
    </div>
    {/* <!-- END PRELOADER --> */}

    {/* <!-- HEADER & MENU --> */}
    <div className="head-top">
        <div className="container">
            <div className="row">
                <div className="lhs">
                    <ul>
                        <li><a href="#!" className="ser-open"><i className="fa fa-search" aria-hidden="true"></i></a></li>
                        <li><a href="about.html">About</a></li>
                        <li><a href="faq.html">FAQ</a></li>
                        <li><a href="contact.html">Contact</a></li>
                    </ul>
                </div>
                <div className="rhs">
                    <ul>
                        <li><a href="tel:+9704462944"><i className="fa fa-phone" aria-hidden="true"></i>&nbsp;+91 75989 84380</a></li>
                        <li><a href="mailto:info@example.com"><i className="fa fa-envelope-o"
                         aria-hidden="true"></i>&nbsp; Kavibarthimatrimony.com</a></li>
                        <li><a href="#!"><i className="fa fa-facebook" aria-hidden="true"></i></a></li>
                        <li><a href="#!"><i className="fa fa-twitter" aria-hidden="true"></i></a></li>
                        <li><a href="#!"><i className="fa fa-whatsapp" aria-hidden="true"></i></a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    {/* <!-- END HEADER & MENU --> */}

    {/* <!-- HEADER & MENU --> */}
    <div className="menu-pop menu-pop1">
        <span className="menu-pop-clo"><i className="fa fa-times" aria-hidden="true"></i></span>
        <div className="inn">
            <img src="images/logo-b.png" alt="" loading="lazy" className="logo-brand-only"/>
            <p><strong>Best Wedding Matrimony</strong> lacinia viverra lectus. Fusce imperdiet ullamcorper metus eu
                fringilla.Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
            <ul className="menu-pop-info">
                <li><a href="#!"><i className="fa fa-phone" aria-hidden="true"></i>+91 75989 84380</a></li>
                <li><a href="#!"><i className="fa fa-whatsapp" aria-hidden="true"></i>+91 75989 84380</a></li>
                <li><a href="#!"><i className="fa fa-envelope-o" aria-hidden="true"></i>help@company.com</a></li>
                <li><a href="#!"><i className="fa fa-map-marker" aria-hidden="true"></i>3812 Lena Lane City Jackson Mississippi</a></li>
            </ul>
            <div className="menu-pop-help">
                <h4>Support Team</h4>
                <div className="user-pro">
                    <img src="images/profiles/1.jpg" alt="" loading="lazy"/>
                </div>
                <div className="user-bio">
                    <h5>Ashley emyy</h5>
                    <span>Senior personal advisor</span>
                    <a href="enquiry.html" className="btn btn-primary btn-sm">Ask your doubts</a>
                </div>
            </div>
            <div className="menu-pop-soci">
                <ul>
                    <li><a href="#!"><i className="fa fa-facebook" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-twitter" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-whatsapp" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-linkedin" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-youtube-play" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-instagram" aria-hidden="true"></i></a></li>
                </ul>
            </div>
        </div>
    </div>
    {/* <!-- END HEADER & MENU --> */}

    {/* <!-- HEADER & MENU --> */}
    <div className="menu-pop menu-pop2">
        <span className="menu-pop-clo"><i className="fa fa-times" aria-hidden="true"></i></span>
        <div className="inn">
            <div className="menu-pop-help">
                <h4>Support Team</h4>
                <div className="user-pro">
                    <img src="images/profiles/1.jpg" alt="" loading="lazy"/>
                </div>
                <div className="user-bio">
                    <h5>Ashley emyy</h5>
                    <span>Senior personal advisor</span>
                    <a href="enquiry.html" className="btn btn-primary btn-sm">Ask your doubts</a>
                </div>
            </div>
            <div className="menu-pop-soci">
                <ul>
                    <li><a href="#!"><i className="fa fa-facebook" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-twitter" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-whatsapp" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-linkedin" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-youtube-play" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-instagram" aria-hidden="true"></i></a></li>
                </ul>
            </div>

            <div className="late-news">
                <h4>Latest news</h4>
                <ul>
                    <li>
                        <div className="rel-pro-img">
                            <img src="images/couples/1.jpg" alt="" loading="lazy"/>
                        </div>
                        <div className="rel-pro-con">
                            <h5>Long established fact that a reader distracted</h5>
                            <span className="ic-date">12 Dec 2023</span>
                        </div>
                        <a href="blog-detail.html" className="fclick"></a>
                    </li>
                    <li>
                        <div className="rel-pro-img">
                            <img src="images/couples/3.jpg" alt="" loading="lazy"/>
                        </div>
                        <div className="rel-pro-con">
                            <h5>Long established fact that a reader distracted</h5>
                            <span className="ic-date">12 Dec 2023</span>
                        </div>
                        <a href="blog-detail.html" className="fclick"></a>
                    </li>
                    <li>
                        <div className="rel-pro-img">
                            <img src="images/couples/4.jpg" alt="" loading="lazy"/>
                        </div>
                        <div className="rel-pro-con">
                            <h5>Long established fact that a reader distracted</h5>
                            <span className="ic-date">12 Dec 2023</span>
                        </div>
                        <a href="blog-detail.html" className="fclick"></a>
                    </li>
                </ul>
            </div>

            {/* <!-- HELP BOX --> */}
            <div className="prof-rhs-help">
                <div className="inn">
                    <h3>Tell us your Needs</h3>
                    <p>Tell us what kind of service you are looking for.</p>
                    <a href="enquiry.html">Register for free</a>
                </div>
            </div>
            {/* <!-- END HELP BOX --> */}
        </div>
    </div>
    {/* <!-- END HEADER & MENU --> */}

    {/* <!-- HEADER & MENU --> */}
    <div className="hom-top">
        <div className="container">
            <div className="row">
                <div className="hom-nav">
                    {/* <!-- LOGO --> */}
                    <div className="logo">
                        <span className="menu desk-menu">
                            <i></i><i></i><i></i>
                        </span>
                        <a href="index.html" className="logo-brand">
                          <span                                
  className="logo-brand-only" 
  style={{ 
    fontWeight: "bold", 
    fontSize: "1.5rem", 
    color: "#d32f2f", 
    fontFamily: "Arial, sans-serif" 
  }}
>
     Ramjimatrimony
</span></a>
                    </div>

                    {/* <!-- TOP MENU --> */}
                    <div className="bl">
                        <ul>
                            <li className="smenu-pare">
                                <span className="smenu">Explore</span>
                                <div className="smenu-open smenu-box">
                                    <div className="container">
                                        <div className="row">
                                            <h4 className="tit">Explore category</h4>
                                            <ul>
                                                <li>
                                                    <div className="menu-box menu-box-2">
                                                        <h5>Browse profiles <span>1200+ Verified profiles</span></h5>
                                                        <span className="explor-cta">More details</span>
                                                        <a href="all-profiles.html" className="fclick"></a>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="menu-box menu-box-1">
                                                        <h5>Wedding page <span>Make reservation</span></h5>
                                                        <span className="explor-cta">More details</span>
                                                        <a href="wedding.html" className="fclick"></a>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="menu-box menu-box-3">
                                                        <h5>All Services<span>Lorem ipsum dummy</span></h5>
                                                        <span className="explor-cta">More details</span>
                                                        <a href="services.html" className="fclick"></a>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="menu-box menu-box-4">
                                                        <h5>Join Now <span>Lorem ipsum dummy</span></h5>
                                                        <span className="explor-cta">More details</span>
                                                        <a href="plans.html" className="fclick"></a>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li className="smenu-pare">
                                <span className="smenu">All pages</span>
                                <div className="smenu-open smenu-multi">
                                    <div className="container">
                                        <div className="row">
                                            <div className="multi-col">
                                                <div className="inn">
                                                    <h4>Page sets 1</h4>
                                                    <ul>
                                                        <li><Link to="profile">All profiles</Link></li>
                                                        <li><a href="profile-details.html">Profile details</a></li>
                                                        <li><a href="wedding.html">Wedding</a></li>
                                                        <li><a href="wedding-video.html">Wedding video</a></li>
                                                        <li><a href="services.html">Our Services</a></li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="multi-col">
                                                <div className="inn">
                                                    <h4>Page sets 2</h4>
                                                    <ul>
                                                        <li><a href="plans.html">Pricing plans</a></li>
                                                        <li><a href="login.html">Login</a></li>
                                                        <li><a href="sign-up.html">Sign-up</a></li>
                                                        <li><a href="photo-gallery.html">Photo gallery</a></li>
                                                        <li><a href="photo-gallery-1.html">Photo gallery 1</a></li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="multi-col">
                                                <div className="inn">
                                                    <h4>Page sets 3</h4>
                                                    <ul>
                                                        <li><a href="contact.html">Contact</a></li>
                                                        <li><a href="about.html">About</a></li>
                                                        <li><a href="blog.html">Blog</a></li>
                                                        <li><a href="blog-detail.html">Blog detail</a></li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="multi-col">
                                                <div className="inn">
                                                    <h4>Page sets 4</h4>
                                                    <ul>
                                                        <li><a href="enquiry.html">Ask your doubts</a></li>
                                                        <li><a href="make-reservation.html">Make Reservation</a></li>
                                                        <li><a href="faq.html">FAQ</a></li>
                                                        <li><a href="coming-soon.html" target="_blank">Coming soon</a>
                                                        </li>
                                                        <li><a href="404.html">404</a></li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="multi-col full">
                                                <div className="inn">
                                                    <h4>User dashboard pages</h4>
                                        <ul>
                                            <li><a href="user-dashboard.html">Dashboard</a></li>
                                            <li><Link to="Profile">My profile</Link></li>
                                            <li><a href="user-interests.html">Interests</a></li>
                                            <li><a href="user-chat.html">Chat lists</a></li>
                                            <li><a href="user-plan.html">My plan details</a></li>
                                            <li><a href="user-setting.html">Profile settings</a></li>
                                            <li><a href="user-profile-edit.html">Edit full profile</a></li>
                                            <li><a href="login.html">Sign in</a></li>
                                        </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li className="smenu-pare">
                                <span className="smenu">Top pages</span>
                                <div className="smenu-open smenu-single">
                                    <ul>
                                        <li><a href="all-profiles.html">All profiles</a></li>
                                        <li><a href="profile-details.html">Profile details</a></li>
                                        <li><a href="wedding.html">Wedding</a></li>
                                        <li><a href="blog.html">Blog</a></li>
                                        <li><a href="blog-detail.html">Blog detail</a></li>
                                        <li><a href="about.html">About</a></li>
                                        <li><a href="contact.html">Contact</a></li>
                                        <li><a href="photo-gallery.html">Photo gallery</a></li>
                                        <li><a href="photo-gallery-1.html">Photo gallery 1</a></li>
                                        <li><a href="login.html">Login</a></li>
                                        <li><a href="sign-up.html">Sign-up</a></li>
                                        <li><a href="plans.html">Pricing plans</a></li>
                                    </ul>
                                </div>
                            </li>
                            <li><a href="plans.html">Plans</a></li>
                            <li><a href="sign-up.html">Register</a></li>
                            <li className="smenu-pare">
                                <span className="smenu">Dashboard</span>
                                <div className="smenu-open smenu-single">
                                    <ul>
                                        <li><a href="user-dashboard.html">Dashboard</a></li>
                                        <li><Link to="Profile">My profile</Link></li>
                                        <li><a href="user-interests.html">Interests</a></li>
                                        <li><a href="user-chat.html">Chat lists</a></li>
                                        <li><a href="user-plan.html">My plan details</a></li>
                                        <li><a href="user-setting.html">Profile settings</a></li>
                                        <li><a href="user-profile-edit.html">Edit full profile</a></li>
                                        <li><a href="login.html">Sign in</a></li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </div>

                    {/* <!-- USER PROFILE --> */}
                    <div className="al">
                        <div className="head-pro">
                            <img src="images/profiles/1.jpg" alt="" loading="lazy"/>
                            <b>Advisor</b><br/>
                            <h4>Ashley emyy</h4>
                            <span className="fclick"></span>
                        </div>
                    </div>

                    {/* <!--MOBILE MENU--> */}
                    <div className="mob-menu">
                        <div className="mob-me-ic">
                            <span className="ser-open mobile-ser">
                                <img src="images/icon/search.svg" alt=""/>
                            </span>
                            <span className="mobile-exprt" data-mob="dashbord">
                                <img src="images/icon/users.svg" alt=""/>
                            </span>
                            <span className="mobile-menu" data-mob="mobile">
                                <img src="images/icon/menu.svg" alt=""/>
                            </span>
                        </div>
                    </div>
                    {/* <!--END MOBILE MENU--> */}
                </div>
            </div>
        </div>
    </div>
    {/* <!-- END HEADER & MENU --> */}

    {/* <!-- MOBILE MENU POPUP --> */}
    <div className="mob-me-all mobile_menu">
        <div className="mob-me-clo"><img src="images/icon/close.svg" alt=""/></div>
        <div className="mv-bus">
            <h4><i className="fa fa-globe" aria-hidden="true"></i> EXPLORE CATEGORY</h4>
            <ul>
                <li><a href="all-profiles.html">Browse profiles</a></li>
                <li><a href="wedding.html">Wedding page</a></li>
                <li><a href="services.html">All Services</a></li>
                <li><a href="plans.html">Join Now</a></li>
            </ul>
            <h4><i className="fa fa-align-center" aria-hidden="true"></i> All Pages</h4>
            <ul>
                <li><a href="all-profiles.html">All profiles</a></li>
                <li><a href="profile-details.html">Profile details</a></li>
                <li><a href="wedding.html">Wedding</a></li>
                <li><a href="wedding-video.html">Wedding video</a></li>
                <li><a href="services.html">Our Services</a></li>
                <li><a href="plans.html">Pricing plans</a></li>
                <li><a href="login.html">Login</a></li>
                <li><a href="sign-up.html">Sign-up</a></li>
                <li><a href="photo-gallery.html">Photo gallery</a></li>
                <li><a href="photo-gallery-1.html">Photo gallery 1</a></li>
                <li><a href="contact.html">Contact</a></li>
                <li><a href="about.html">About</a></li>
                <li><a href="blog.html">Blog</a></li>
                <li><a href="blog-detail.html">Blog detail</a></li>
                <li><a href="enquiry.html">Ask your doubts</a></li>
                <li><a href="make-reservation.html">Make Reservation</a></li>
                <li><a href="faq.html">FAQ</a></li>
                <li><a href="coming-soon.html" target="_blank">Coming soon</a></li>
                <li><a href="404.html">404</a></li>
            </ul>
            <div className="menu-pop-help">
                <h4>Support Team</h4>
                <div className="user-pro">
                    <img src="images/profiles/1.jpg" alt="" loading="lazy"/>
                </div>
                <div className="user-bio">
                    <h5>Ashley emyy</h5>
                    <span>Senior personal advisor</span>
                    <a href="enquiry.html" className="btn btn-primary btn-sm">Ask your doubts</a>
                </div>
            </div>
            <div className="menu-pop-soci">
                <ul>
                    <li><a href="#!"><i className="fa fa-facebook" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-twitter" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-whatsapp" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-linkedin" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-youtube-play" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-instagram" aria-hidden="true"></i></a></li>
                </ul>
            </div>
            <div className="late-news">
                <h4>Latest news</h4>
                <ul>
                    <li>
                        <div className="rel-pro-img">
                            <img src="images/couples/1.jpg" alt="" loading="lazy"/>
                        </div>
                        <div className="rel-pro-con">
                            <h5>Long established fact that a reader distracted</h5>
                            <span className="ic-date">12 Dec 2023</span>
                        </div>
                        <a href="blog-detail.html" className="fclick"></a>
                    </li>
                    <li>
                        <div className="rel-pro-img">
                            <img src="images/couples/3.jpg" alt="" loading="lazy"/>
                        </div>
                        <div className="rel-pro-con">
                            <h5>Long established fact that a reader distracted</h5>
                            <span className="ic-date">12 Dec 2023</span>
                        </div>
                        <a href="blog-detail.html" className="fclick"></a>
                    </li>
                    <li>
                        <div className="rel-pro-img">
                            <img src="images/couples/4.jpg" alt="" loading="lazy"/>
                        </div>
                        <div className="rel-pro-con">
                            <h5>Long established fact that a reader distracted</h5>
                            <span className="ic-date">12 Dec 2023</span>
                        </div>
                        <a href="blog-detail.html" className="fclick"></a>
                    </li>
                </ul>
            </div>
            <div className="prof-rhs-help">
                <div className="inn">
                    <h3>Tell us your Needs</h3>
                    <p>Tell us what kind of service you are looking for.</p>
                    <a href="enquiry.html">Register for free</a>
                </div>
            </div>
        </div>
    </div>
    {/* <!-- END MOBILE MENU POPUP --> */}

    {/* <!-- MOBILE USER PROFILE MENU POPUP --> */}
    <div className="mob-me-all dashbord_menu">
        <div className="mob-me-clo"><img src="images/icon/close.svg" alt=""/></div>
        <div className="mv-bus">
            <div className="head-pro">
                <img src="images/profiles/1.jpg" alt="" loading="lazy"/>
                <b>user profile</b><br/>
                <h4>Ashley emyy</h4>
            </div>
            <ul>
                <li><a href="login.html">Login</a></li>
                <li><a href="sign-up.html">Sign-up</a></li>
                <li><a href="plans.html">Pricing plans</a></li>
                <li><a href="all-profiles.html">Browse profiles</a></li>
            </ul>
        </div>
    </div>
    {/* <!-- END USER PROFILE MENU POPUP --> */}

    {/* <!-- REGISTER --> */}
    <section>
  <div className="login">
    <div className="container">
      <div className="row">
        <div className="inn">
          <div className="lhs">
            <div className="tit">
              <h2>
                Now <b>Find your life partner</b> Easy and fast.
              </h2>
            </div>

            {/* ✅ Your Image */}
            <div style={{ position: "relative", width: "100%", height: "400px" }}>
              <img
                src="images/gallery/matri2.jpg"
                alt="Circular"
                style={{
                  width: "270px",
                  height: "270px",
                  borderRadius: "40%",
                  objectFit: "cover",
                  objectPosition: "12% 50%",
                  position: "absolute",
                  top: "20px",
                  right: "20px",
                }}
              />
            </div>
            <div className="log-bg">&nbsp;</div>
          </div>

          <div className="rhs">
            <div>
              <div className="form-tit">
                <center>
                  <h3 style={{ color: "red" }}>
                    Welcome {formData?.gender === "Male" ? "Mr." : "Ms."}{" "}
                    {formData?.full_name}
                  </h3>

                  <h1>Sign up to Matrimony</h1>
                </center>
              </div>

              <div className="form-login">
                <form onSubmit={handleSubmit}>
                  {/* Row 1: Name + Phone */}
                  <div style={{ display: "flex", gap: "20px" }}>
                    {/* Name */}
                    <div className="form-group" style={{ flex: 1 }}>
                      <label className="lb">Name:</label>
                      <input
                        type="text"
                        className="form-control"
                        name="full_name"
                        value={formData.full_name}
                        readOnly
                      />
                    </div>

                    {/* Phone */}
                    <div className="form-group" style={{ flex: 1 }}>
                      <label className="lb">Phone Number:</label>
                      <input
                        type="tel"
                        className="form-control"
                        name="phone"
                        value={formData.mobile}
                        readOnly
                      />
                    </div>
                  </div>

                  {/* Row 2: DOB + Password */}
                  <div style={{ display: "flex", gap: "20px" }}>
                    <div className="form-group" style={{ flex: 1 }}>
                      <label className="lb">Date of Birth / Age:</label>
                      <input
                        type="text"
                        className="form-control"
                        value={
                          formData.dob
                            ? `${formData.dob} / ${formData.age || ""} yrs`
                            : ""
                        }
                        onFocus={(e) => (e.target.type = "date")}
                        onBlur={(e) => (e.target.type = "text")}
                        name="dob"
                        onChange={handleChange}
                        placeholder="Select DOB"
                        required
                      />
                    </div>
                    <div className="form-group" style={{ flex: 1 }}>
                      <label className="lb">Create Password:</label>
                      <input
                        type="password"
                        className="form-control"
                        name="password"
                        onChange={handleChange}
                        placeholder="Enter password"
                        required
                      />
                    </div>
                  </div>

                  {/* Row 3: Religion + Caste */}
                  <div style={{ display: "flex", gap: "20px" }}>
                    <div className="form-group" style={{ flex: 1 }}>
                      <label className="lb">Religion:</label>
                      <select
                        className="form-control"
                        name="religion"
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Religion</option>
                        <option value="Hindu">Hindu</option>
                        <option value="Christian">Christian</option>
                        <option value="Muslim">Muslim</option>
                        <option value="No Religion Belief">
                          No Religion Belief
                        </option>
                        <option value="Other">Other</option>
                        <option value="Parsi">Parsi</option>
                        <option value="Sikh">Sikh</option>
                        <option value="Spiritual - not religious">
                          Spiritual - not religious
                        </option>
                      </select>
                    </div>
                    <div className="form-group" style={{ flex: 1 }}>
                      <label className="lb">Caste:</label>
                      <select
                        name="caste"
                        className="form-control"
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select</option>
                        <option value="Aasaari">Aasaari</option>
                        <option value="Aathi Dravidar">Aathi Dravidar</option>
                        <option value="Achaari">Achaari</option>
                      </select>
                    </div>
                  </div>

                  {/* Row 4: District + Taluk */}
                  <div style={{ display: "flex", gap: "20px" }}>
                    <div className="form-group" style={{ flex: 1 }}>
                      <label className="lb">District:</label>
                      <input
                        type="text"
                        className="form-control"
                        name="district"
                        onChange={handleChange}
                        placeholder="Enter district"
                        required
                      />
                    </div>
                    <div className="form-group" style={{ flex: 1 }}>
                      <label className="lb">Taluk:</label>
                      <input
                        type="text"
                        className="form-control"
                        name="taluk"
                        onChange={handleChange}
                        placeholder="Enter taluk"
                        required
                      />
                    </div>
                  </div>

                  {/* Row 5: Email + Job Type */}
                  <div style={{ display: "flex", gap: "20px" }}>
                    <div className="form-group" style={{ flex: 1 }}>
                      <label className="lb">Email:</label>
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        onChange={handleChange}
                        placeholder="Enter email"
                        required
                      />
                    </div>
                    <div className="form-group" style={{ flex: 1 }}>
                      <label className="lb">Job Type:</label>
                      <input
                        type="text"
                        className="form-control"
                        name="jobType"
                        onChange={handleChange}
                        placeholder="Enter job type"
                      />
                    </div>
                  </div>

                  {/* Checkbox */}
                  <div className="form-group form-check">
                    <label className="form-check-label">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="agree"
                        onChange={handleChange}
                        required
                      />
                      Creating an account means you’re okay with our{" "}
                      <a href="#!">Terms of Service</a>, Privacy Policy, and
                      Notification Settings.
                    </label>
                  </div>

                  <button type="submit" className="btn btn-primary">
                    Create Account
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

      {/* <!-- END --> */}

    {/* <!-- FOOTER --> */}
    <section className="wed-hom-footer">
        <div className="container">
            <div className="row foot-supp">
                <h2><span>Free support:</span> +91 75989 84380 &nbsp;&nbsp;|&nbsp;&nbsp; <span>Email:</span>
                    info@example.com</h2>
            </div>
            <div className="row wed-foot-link wed-foot-link-1">
                <div className="col-md-4">
                    <h4>Get In Touch</h4>
                    <p>Address: 3812 Lena Lane City Jackson Mississippi</p>
                    <p>Phone: <a href="tel:+917904462944">+91 75989 84380</a></p>
                    <p>Email: <a href="mailto:info@example.com">info@example.com</a></p>
                </div>
                <div className="col-md-4">
                    <h4>HELP &amp; SUPPORT</h4>
                    <ul>
                        <li><a href="about-us.html">About company</a>
                        </li>
                        <li><a href="#!">Contact us</a>
                        </li>
                        <li><a href="#!">Feedback</a>
                        </li>
                        <li><a href="about-us.html#faq">FAQs</a>
                        </li>
                        <li><a href="about-us.html#testimonials">Testimonials</a>
                        </li>
                    </ul>
                </div>
                <div className="col-md-4 fot-soc">
                    <h4>SOCIAL MEDIA</h4>
                    <ul>
                        <li><a href="#!"><img src="images/social/1.png" alt=""/></a></li>
                        <li><a href="#!"><img src="images/social/2.png" alt=""/></a></li>
                        <li><a href="#!"><img src="images/social/3.png" alt=""/></a></li>
                        <li><a href="#!"><img src="images/social/5.png" alt=""/></a></li>
                    </ul>
                </div>
            </div>
            <div className="row foot-count">
                <p>Company name Site - Trusted by over thousands of Boys & Girls for successfull marriage. <a
                        href="sign-up.html" className="btn btn-primary btn-sm">Join us today !</a></p>
            </div>
        </div>
    </section>
    {/* <!-- END --> */}
    {/* <!-- COPYRIGHTS --> */}
    <section>
        <div className="cr">
            <div className="container">
                <div className="row">
                    <p>Copyright © <span id="cry">2020-2025</span> <a href="#!" target="_blank">Company.com</a> All
                        rights reserved.</p>
                </div>
            </div>
        </div>
    </section>
    </div>
  )
}


